import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

interface Routine {
  id: string;
  title: string;
  description: string;
  icon: string;
  time: string;
}

const RoutinePage: React.FC = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [selectedRoutine, setSelectedRoutine] = useState<Routine | null>(null);
  const [isStarting, setIsStarting] = useState(false);

  const ROUTINES: Routine[] = [
    {
      id: 'morning',
      title: t('routine.morning.title'),
      description: t('routine.morning.description'),
      icon: '🌅',
      time: '07:00'
    },
    {
      id: 'focus',
      title: t('routine.focus.title'),
      description: t('routine.focus.description'),
      icon: '🎯',
      time: '14:00'
    },
    {
      id: 'evening',
      title: t('routine.evening.title'),
      description: t('routine.evening.description'),
      icon: '🌙',
      time: '20:00'
    }
  ];

  const handleStartRoutine = (routine: Routine) => {
    setSelectedRoutine(routine);
    setIsStarting(true);
    
    // 3초 후 채팅 페이지로 이동
    setTimeout(() => {
      navigate('/chat', { 
        state: { 
          routineId: routine.id,
          routineTitle: routine.title,
          routineDescription: routine.description
        }
      });
    }, 3000);
  };

  return (
    <div className="max-w-4xl mx-auto">
      <div className="card p-5 mb-5">
        <h1 className="text-xl font-bold text-gray-900 mb-2">
          {t('nav.routine')}
        </h1>
        <p className="text-sm text-gray-600">
          {t('routine.subtitle')}
        </p>
      </div>

      {!isStarting ? (
        <div className="space-y-5">
          {ROUTINES.map((routine) => (
            <div key={routine.id} className="card p-5">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  <div className="text-3xl">{routine.icon}</div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900">
                      {routine.title}
                    </h3>
                    <p className="text-sm text-gray-600 mt-1">
                      {routine.description}
                    </p>
                    <p className="text-xs text-gray-500 mt-1">
                      {routine.time}
                    </p>
                  </div>
                </div>
                                  <button
                    onClick={() => handleStartRoutine(routine)}
                    className="btn-primary px-5 py-2.5"
                  >
                    {t('routine.start')}
                  </button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="card p-10 text-center">
          <div className="text-5xl mb-5">🎉</div>
          <h2 className="text-xl font-bold text-gray-900 mb-3">
            {selectedRoutine?.title} {t('routine.starting')}
          </h2>
          <p className="text-sm text-gray-600 mb-6">
            {selectedRoutine?.description}
          </p>
          <div className="flex justify-center">
            <div className="flex space-x-1">
              <div className="w-2.5 h-2.5 bg-mint rounded-full animate-bounce"></div>
              <div className="w-2.5 h-2.5 bg-mint rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
              <div className="w-2.5 h-2.5 bg-mint rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
            </div>
          </div>
          <p className="text-xs text-gray-500 mt-3">
            {t('routine.preparing')}
          </p>
        </div>
      )}
    </div>
  );
};

export default RoutinePage; 